import '../styles/templates/doc.scss'

import * as Shortcodes from '../components/shortcodes'

import React, { useEffect, useState } from 'react'

import Layout from '../components/layout'
import { MDXProvider } from '@mdx-js/react'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import SEO from '../components/seo'
import TOC from '../components/toc'
import { getDocInfo, setNavShow } from '../state'
import { graphql } from 'gatsby'
import replaceInternalHref from '../lib/replaceInternalHref'
import { useDispatch } from 'react-redux'

const Doc = ({ pageContext: { relativeDir, pathPrefix, fullPath }, data }) => {
  const { mdx, toc } = data
  const { frontmatter, tableOfContents } = mdx
  const docRefArray = relativeDir.split('/')

  const [showProgress, setShowProgress] = useState(false)
  const [showNav, setShowNav] = useState(true)
  const [readingProgress, setReadingProgress] = useState(0)

  function addStyleToQuote(quote, type) {
    quote.classList.add('doc-blockquote')
    quote.classList.add(type)
  }

  function optimizeBlockquote() {
    const blockquoteList = document.getElementsByTagName('blockquote')
    Array.from(blockquoteList).forEach((quote) => {
      if (quote.children[0] && quote.children[0].children[0]) {
        const labelText = quote.children[0].children[0].innerHTML

        switch (labelText) {
          case '注意：':
            addStyleToQuote(quote, 'note')
            break
          case '警告：':
            addStyleToQuote(quote, 'warning')
            break
          case '建议：':
            addStyleToQuote(quote, 'tips')
            break
          case '错误：':
            addStyleToQuote(quote, 'error')
            break
          default:
            break
        }
      }
    })
  }

  useEffect(() => {
    optimizeBlockquote()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const footer = document.querySelector('.footer.cl-Footer')
    const footerHeight = footer ? footer.getBoundingClientRect().height : 0

    let isReachFooter = false

    const scrollListener = () => {
      const winScrollHeight = document.documentElement.scrollHeight
      const winClientHeight = document.documentElement.clientHeight
      const winScrollTop = document.documentElement.scrollTop
      const toFooter = winScrollHeight - winClientHeight - footerHeight

      setShowProgress(winScrollTop > 0)
      setShowNav(winScrollTop < 200)

      if (winScrollTop > toFooter && !isReachFooter) {
        isReachFooter = true
      }

      if (winScrollTop < toFooter && isReachFooter) {
        isReachFooter = false
      }

      const height = winScrollHeight - winClientHeight
      const scrolled = ((winScrollTop / height) * 100).toFixed()
      setReadingProgress(scrolled)
    }

    window.addEventListener('scroll', scrollListener)

    return () => window.removeEventListener('scroll', scrollListener)
  }, [])

  const dispatch = useDispatch()

  useEffect(
    () => {
      replaceInternalHref(docRefArray[0])

      dispatch(
        getDocInfo({
          type: docRefArray[0],
        })
      )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  useEffect(
    () => {
      dispatch(
        setNavShow({
          showNav,
        })
      )
    }, [showNav]
  )

  function replaceItemURL(item) {
    let itemURL
    if (item) {
      itemURL = item
        .replace(/\s/g, '-')
        .replace(/[^-\w\u4E00-\u9FFF]*/g, '')
        .toLowerCase()
    }

    return itemURL
  }

  function renderItems(items, num1, style = {}) {
    return (
      <ul style={style}>
        {items.map((item, num2) => (
          <li key={item.url}>
            <a
              href={'#' + replaceItemURL(item.url)}
              dangerouslySetInnerHTML={{
                __html: `${num1}.${num2 + 1} ${item.title}`,
              }}
            />
            {item.items && renderItems(item.items, `${num1}.${num2 + 1}`, { paddingLeft: 10 })}
          </li>
        ))}
      </ul>
    )
  }

  const handleShowDocMenu = (e) => {
    const docMenu = e.target
    const toc = docMenu.nextSibling

    docMenu.classList.toggle('active')
    toc.classList.toggle('show')
  }

  return (
    <Layout forbidResetDocInfo={true}>
      <SEO title={frontmatter.title} />
      <article className={`cl-Doc ${showNav ? '' : 'cl-nav-none'}`}>
        {showProgress && (
          <progress
            className="progress is-primary doc-progress"
            value={readingProgress}
            max="100"
          >
            {readingProgress}
          </progress>
        )}
        <section className="section container">
          <div className="columns">
            <div className="column is-2 left-column">
              <div
                role="button"
                tabIndex={0}
                className="doc-menu-mobile"
                onClick={handleShowDocMenu}
                onKeyDown={handleShowDocMenu}
              >
                文档目录
              </div>
              <TOC
                data={toc.nodes[0]}
                pathPrefix={`/${pathPrefix}`}
                fullPath={fullPath}
              />
            </div>
            <div className="column is-10">
              <section className="markdown-body doc-content">
                {(tableOfContents?.items?.length > 1 || tableOfContents?.items?.[0]?.items?.length) && (
                  <div className="doc-catalog">
                    <p>目录</p>
                    <div className="doc-catalog-content">
                      {renderItems(tableOfContents.items, 1)}
                    </div>
                  </div>
                )}
                <MDXProvider components={Shortcodes}>
                  <MDXRenderer>{mdx.body}</MDXRenderer>
                </MDXProvider>
              </section>
            </div>
            {/*<div className="column is-2 doc-toc-column">
              <section className="doc-toc">
                <div className="title">本页导航</div>
                <div className="toc-content">
                  {tableOfContents.items && renderItems(tableOfContents.items)}
                </div>
              </section>
            </div>*/}
          </div>
        </section>
      </article>
    </Layout>
  )
}

export const query = graphql`
  query($id: String, $langCollection: String, $tocPath: String) {
    mdx(id: { eq: $id }) {
      frontmatter {
        title
      }
      body
      tableOfContents
    }

    toc: allMdx(
      filter: {
        fields: {
          langCollection: { eq: $langCollection }
          relativePath: { eq: $tocPath }
        }
      }
    ) {
      nodes {
        rawBody
      }
    }
  }
`

export default Doc
